import { IconButton, Stack, Tooltip, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { LockedPadlockOMIcon } from '@omnea-app/icons'

/** Stands in for a field value the caller may not see. The dots have a fixed length, so they reveal nothing about the value. */
export const RestrictedFieldValue: FC = () => {
  const { t } = useTranslation('common')
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography color="text.muted" aria-hidden>
        •••••••••
      </Typography>
      <Tooltip title={t('restricted-field.no-access')}>
        <IconButton size="small">
          <LockedPadlockOMIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  )
}
